var data = new WeakMap();

function getAnimationData(element) {
  if (!data.has(element)) {
    data.set(element, {
      transforms: [],
      animations: {},
      generators: {},
      prevGeneratorState: {}
    });
  }

  return data.get(element);
}

export { getAnimationData };